var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSetupAlter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.1428 10.8571V4M17.1428 17.7143V20",
    stroke: "#7B7986",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.85718 13.1429L6.85718 20M6.85718 6.28571L6.85718 4",
    stroke: "#7B7986",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.143 17.1425C18.721 17.1425 20.0002 15.8633 20.0002 14.2854C20.0002 12.7074 18.721 11.4282 17.143 11.4282C15.5651 11.4282 14.2859 12.7074 14.2859 14.2854C14.2859 15.8633 15.5651 17.1425 17.143 17.1425Z",
    stroke: "#7B7986",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.85697 6.85749C5.27901 6.85749 3.99983 8.13668 3.99983 9.71463C3.99983 11.2926 5.27901 12.5718 6.85697 12.5718C8.43492 12.5718 9.71411 11.2926 9.71411 9.71463C9.71411 8.13668 8.43493 6.85749 6.85697 6.85749Z",
    stroke: "#7B7986",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSetupAlter);
export default __webpack_public_path__ + "static/media/setupAlter.e565f84078eac2063ec96e46edc40ebd.svg";
export { ForwardRef as ReactComponent };